var Network = /* @__PURE__ */ ((Network2) => {
  Network2["Mainnet"] = "mainnet";
  Network2["Devnet"] = "devnet";
  Network2["Testnet"] = "testnet";
  Network2["Localnet"] = "localnet";
  Network2["Custom"] = "custom";
  return Network2;
})(Network || {});
function getAllNetworks() {
  const networksStringified = '{\n  "mainnet":\n    {\n      "id": "mainnet",\n      "name": "Mainnet",\n      "url": "https://indexer.mainnet.iota.cafe",\n      "graphql": "https://graphql.mainnet.iota.cafe",\n      "explorer": "https://explorer.rebased.iota.org",\n      "chain": "iota:mainnet",\n      "metadata":\n        { "stardustIndexer": "https://stardust-indexer.mainnet.iota.cafe" },\n      "kiosk":\n        {\n          "royaltyRulePackageId": "0xe49f2f23baf6c88a4c18478ac375033eea1f5609f2be6359b417208ea96f555d",\n          "kioskLockRulePackageId": "0xe49f2f23baf6c88a4c18478ac375033eea1f5609f2be6359b417208ea96f555d",\n          "floorPriceRulePackageId": "0xe49f2f23baf6c88a4c18478ac375033eea1f5609f2be6359b417208ea96f555d",\n          "personalKioskRulePackageId": "0xe49f2f23baf6c88a4c18478ac375033eea1f5609f2be6359b417208ea96f555d"\n        }\n    },\n  "testnet":\n    {\n      "id": "testnet",\n      "name": "Testnet",\n      "url": "https://indexer.testnet.iota.cafe",\n      "graphql": "https://graphql.testnet.iota.cafe",\n      "explorer": "https://explorer.rebased.iota.org",\n      "chain": "iota:testnet",\n      "faucetWebsite": "https://faucet.testnet.iota.cafe",\n      "kiosk":\n        {\n          "royaltyRulePackageId": "0x975f749f57701209454e4b9b9e33825ccb6a9abf57de2ce86979e5fa86c343f2",\n          "kioskLockRulePackageId": "0x975f749f57701209454e4b9b9e33825ccb6a9abf57de2ce86979e5fa86c343f2",\n          "floorPriceRulePackageId": "0x975f749f57701209454e4b9b9e33825ccb6a9abf57de2ce86979e5fa86c343f2",\n          "personalKioskRulePackageId": "0x975f749f57701209454e4b9b9e33825ccb6a9abf57de2ce86979e5fa86c343f2"\n        }\n    },\n  "devnet":\n    {\n      "id": "devnet",\n      "name": "Devnet",\n      "url": "https://indexer.devnet.iota.cafe",\n      "graphql": "https://graphql.devnet.iota.cafe",\n      "explorer": "https://explorer.rebased.iota.org",\n      "chain": "iota:devnet",\n      "faucetWebsite": "https://faucet.devnet.iota.cafe",\n      "metadata":\n        { "stardustIndexer": "https://stardust-indexer.devnet.iota.cafe" }\n    }\n}';
  if (!networksStringified) {
    throw new Error('"IOTA_NETWORKS" env var is not set.');
  }
  let networks;
  try {
    networks = JSON.parse(networksStringified);
  } catch {
    throw new Error('Failed to parse env var "IOTA_NETWORKS".');
  }
  return networks;
}
function getNetwork(network) {
  const networks = getAllNetworks();
  const requestedNetwork = networks[network] ?? network;
  return requestedNetwork;
}
function getDefaultNetwork() {
  return "mainnet";
}
function getRpcUrl(network) {
  return getNetwork(network).url;
}
function getFullnodeUrl(network) {
  return getRpcUrl(network);
}
function getGraphQLUrl(network) {
  return getNetwork(network).graphql;
}
export {
  Network,
  getAllNetworks,
  getDefaultNetwork,
  getFullnodeUrl,
  getGraphQLUrl,
  getNetwork,
  getRpcUrl
};
//# sourceMappingURL=network.js.map
